import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions(
	{
		setOrigins: ['origins'],
		setLoadingOrigins: null,
		setLoadingDestinations: null,
		setDestinations: ['destinations'],
		setIFrameLoaded: ['isIframeLoaded'],
		setSearchOriginTerm: ['searchOriginTerm'],
		setSearchDestinationTerm: ['searchDestinationTerm'],
	},
	{
		prefix: 'trip-search/',
	}
)

const initialState = {
	origins: [],
	destinations: [],
	searchOriginTerm: '',
	isIframeLoaded: false,
	areOriginsLoaded: false,
	isLoadingOrigins: false,
	searchDestinationTerm: '',
	notLoadingDestinations: true,
}

const setOrigins = (state = initialState, { origins }) => ({
	...state,
	origins,
	areOriginsLoaded: true,
	isLoadingOrigins: false,
})

const setSearchOriginTerm = (state = initialState, { searchOriginTerm }) => ({
	...state,
	searchOriginTerm,
})

const setIFrameLoaded = (state = initialState, { isIframeLoaded }) => ({
	...state,
	isIframeLoaded,
})

const setLoadingOrigins = (state = initialState) => ({
	...state,
	isLoadingOrigins: true,
})

const setDestinations = (state = initialState, { destinations }) => ({
	...state,
	destinations,
	notLoadingDestinations: true,
})

const setSearchDestinationTerm = (
	state = initialState,
	{ searchDestinationTerm }
) => ({
	...state,
	searchDestinationTerm,
})

const setLoadingDestinations = (state = initialState) => ({
	...state,
	notLoadingDestinations: false,
})

export default createReducer(initialState, {
	[Types.SET_ORIGINS]: setOrigins,
	[Types.SET_DESTINATIONS]: setDestinations,
	[Types.SET_I_FRAME_LOADED]: setIFrameLoaded,
	[Types.SET_LOADING_ORIGINS]: setLoadingOrigins,
	[Types.SET_SEARCH_ORIGIN_TERM]: setSearchOriginTerm,
	[Types.SET_LOADING_DESTINATIONS]: setLoadingDestinations,
	[Types.SET_SEARCH_DESTINATION_TERM]: setSearchDestinationTerm,
})
